var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      attrs: {
        src: require(`.././../../assets/images/upgrade-now@2x.png`),
        srcset: `${require(`../../../assets/images/upgrade-now@1x.png`)} 1x, ${require(`../../../assets/images/upgrade-now@2x.png`)} 2x, ${require(`../../../assets/images/upgrade-now@3x.png`)} 3x, ${require(`../../../assets/images/upgrade-now@4x.png`)} 4x`,
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-body" }, [
      _c("h2", [_vm._v(_vm._s(_vm._f("trans")("Unlock Starter Features")))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm._f("trans")(
              "Dive into a world of limitless creativity and make your mark as an elite image creator."
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.getUpgradeText) } }),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm._f("trans")("Your artistic journey awaits!"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }